import { FunctionComponent, useEffect } from 'react';
import { baseEventData as __baseEventData, baseEventDataType, LoginMethodsEnum, LoginMethodsType } from './constants';
import { trackEvent } from '../../utils/event-tracking/track-event';
import { getCustomerId, getHashedCustomerEmail } from '../../utils/event-tracking/event-data';

export const trackLoginComplete = ({
  baseEventData = __baseEventData.default,
  loginMethod = 'email',
  isCreate = false,
}: {
  baseEventData?: baseEventDataType;
  loginMethod?: LoginMethodsType;
  isCreate?: boolean;
}) => {
  trackEvent({
    ...baseEventData,
    event: 'custom.form.complete',
    group: isCreate ? 'create an account' : 'login',
    eventLabel: loginMethod,
    data: {
      customerId: getCustomerId(),
      customerEmail: getHashedCustomerEmail(),
    },
  });
};

export const trackLoginStart = ({
  baseEventData = __baseEventData.default,
  loginMethod = 'email',
  isCreate,
}: {
  baseEventData?: baseEventDataType;
  loginMethod?: LoginMethodsType;
  isCreate?: boolean;
}) => {
  trackEvent({
    ...baseEventData,
    event: 'custom.account.interactions.click',
    group: `${isCreate === undefined ? 'login or create' : isCreate ? 'create an account' : 'login'}`,
    eventLabel: loginMethod === 'email' ? 'my account' : loginMethod,
  });
};

export const trackLogout = ({ baseEventData = __baseEventData.default }: { baseEventData?: baseEventDataType }) => {
  trackEvent({
    ...baseEventData,
    event: 'custom.account.interactions.click',
    group: `logout`,
    data: {
      customerId: getCustomerId(),
      customerEmail: getHashedCustomerEmail(),
    },
  });
};

export const useLoginTracking = ({
  baseEventData = __baseEventData.default,
}: {
  baseEventData?: baseEventDataType;
}): FunctionComponent => {
  useEffect(() => {
    const queryParams = new URL(window.location.href).searchParams;

    if (queryParams.has('loginMethod')) {
      trackLoginComplete({
        baseEventData,
        loginMethod: LoginMethodsEnum[(queryParams.get('loginMethod') ?? 'email').toLowerCase()],
        isCreate: queryParams.has('newUser'),
      });
    }
  }, []);

  return null;
};
